import { ROUTE_ERROR_TEXT } from '../constants/RouteError.constants';

const sessionStorageKey = ROUTE_ERROR_TEXT.chunkLoadError.sessionStorageKey;

/**
 * Handles refreshing the page when a chunk load error is detected, using session storage to prevent infinite reload loops.
 */
export const handleRefresh = () => {
  // Prevent infinite reload loops if the chunk error persists
  const hasReloaded = sessionStorage.getItem(sessionStorageKey);

  if (!hasReloaded) {
    sessionStorage.setItem(sessionStorageKey, 'true');
    // Force a refresh to load the latest app files
    window.location.reload();
  }
};
